import { render, staticRenderFns } from "./MyAccountModal.vue?vue&type=template&id=dc4a93b4&scoped=true"
import script from "./MyAccountModal.vue?vue&type=script&lang=js"
export * from "./MyAccountModal.vue?vue&type=script&lang=js"
import style0 from "./MyAccountModal.vue?vue&type=style&index=0&id=dc4a93b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4a93b4",
  null
  
)

export default component.exports